export const amazonColors = {
  alexa: {
    blue: '#05A0D1',
  },
  prime: {
    blue: '#0578FF',
    yellow: '#FFD814',
  },
  squidInk: '#232F3E',
  orange: '#FF6101',
} as const;
